import { Outlet, RouteObject } from 'react-router-dom'
import { ProtectedRoute } from 'lib/rbac'

const basePath = 'invoices'

export const invoicesRoutes = (): RouteObject[] => [
  {
    path: basePath,
    element: <Outlet />,
    children: [
      {
        path: 'new/:id?',
        lazy: async () => {
          const { CreateInvoicePage } = await import('./pages')
          return {
            Component: () => (
              <ProtectedRoute permission="org.invoice:create">
                <CreateInvoicePage />
              </ProtectedRoute>
            )
          }
        }
      },
      {
        path: ':id',
        lazy: async () => {
          const { EditInvoicePage } = await import('./pages')
          return {
            Component: () => (
              <ProtectedRoute permission="org.invoice:read">
                <EditInvoicePage />
              </ProtectedRoute>
            )
          }
        }
      }
    ]
  }
]

export const invoicePaths = {
  new: () => `/${basePath}/new`,
  creationFlow: (id: string) => `/${basePath}/new/${id}`,
  edit: (id: string) => `/${basePath}/${id}`
}

export const isInvoiceRoutesPath = (path: string): boolean => {
  return /^\/invoices\/(.+)$/.test(path)
}
